module.exports = __webpack_public_path__ + "img/comment-icon.3975416b.svg";